import { useEffect, useState } from "react";
import { DiscordAuthMessage } from "../services/auth/discord";
import { formattedDiscordMessage } from "./../services/auth/discord";

export const useDiscordAuth = () => {
  const [discordAuthCode, setDiscordAuthCode] = useState("");
  const [discordError, setDiscordError] = useState("");

  /**
   * Listens for message from the Discord OAuth redirect.
   */
  useEffect(() => {
    window.addEventListener("message", handleDiscordAuthMessage);
  }, []);

  const handleDiscordAuthMessage = (e: any) => {
    if (!e.data?.startsWith) {
      return;
    }

    if (e.data.startsWith(DiscordAuthMessage.Success)) {
      document.removeEventListener("message", handleDiscordAuthMessage);
      setDiscordAuthCode(
        formattedDiscordMessage(DiscordAuthMessage.Success, e.data),
      );
    } else if (e.data.startsWith(DiscordAuthMessage.Error)) {
      setDiscordError(
        formattedDiscordMessage(DiscordAuthMessage.Error, e.data),
      );
    }
  };

  return {
    discordAuthCode,
    discordError,
    handleDiscordAuthMessage,
  };
};
